/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "446")


  
    
export interface API48203Item {
  
  /**  */
  id?: number;
  
  /** 执行人用户id */
  userId?: string;
  
  /** 执行人姓名 */
  userName?: string;
  
  /** 头像 */
  userLogo?: string;
  
  /** 用户状态(NORMAL:正常,DISABLE:禁用,RESIGN:离职),详见UserStatusEnum */
  userStatus?: string;
  
  /** <pre>,执行人的任务处理状态(1:未开始;2:进行中;3:已关闭;5:已完成),详见枚举定义：com.ywwl.foundation.teamwork.client.enums.TaskStatusEnum,<pre> */
  executeStatus?: number;
  
  /** 任务更新时间yyyy-MM-ddHH:mm */
  updatedAt?: any;
  
  /** 任务回复状态（0:待确认，1：已接受，2:已拒绝） */
  replyStatus?: number;
  
};
    
  



export interface API48203Req {
  
  /** 任务查询类型(1:我执行的任务,2:我发起的任务,3:抄送我的任务,4:待我处理的任务),默认为默认查询类型数据不处理,@seeTaskQueryTypeEnum */
  queryType?: string;
    
  /** 任务ID */
  taskId?: string;
    
};



export interface API48203Res {
  /** task_id  */
  taskId?: number;
  /** 父任务id  */
  parentTaskId?: number;
  /** 任务标题  */
  taskTitle?: string;
  /** 任务描述  */
  taskDesc?: string;
  /** <pre>,任务状态(1:未开始;2:进行中;3:已关闭;5:已完成),,详见枚举定义：com.ywwl.foundation.teamwork.client.enums.TaskStatusEnum,<pre>  */
  taskStatus?: number;
  /** 任务完成标准(1:或签,2:会签，默认1)，详见TaskCompleteTypeEnum  */
  taskCompleteType?: number;
  /** 业务域数据字典中配置,@seecom.ywwl.foundation.teamwork.domain.factory.DicDataFactory  */
  bizDomain?: number;
  /** 优先级(1:较低,2:普通,3:紧急,4:非常紧急),详见TaskPriorityEnum  */
  taskPriority?: number;
  /** 能否处理已逾期的任务(0:否,1:能)  */
  canExecOverdue?: boolean;
  /** 计划开始时间  */
  startTime?: any;
  /** 计划完成时间  */
  endTime?: any;
  /** 任务评级(1~5)  */
  evaluateLevel?: number;
  /** 任务发起人  */
  creator?: string;
  /** 任务创建人头像  */
  creatorLogo?: string;
  /** 任务发起人姓名  */
  creatorName?: string;
  /** 用户状态,,@seecom.ywwl.foundation.teamwork.client.enums.UserStatusEnum  */
  creatorStatus?: string;
  /** 更新时间yyyy-MM-ddHH:mm  */
  updatedAt?: any;
  /** 执行人列表 ,WorkTaskExecutorVO  */
  workTaskExecutorList?: API48203Item[];
  /** 抄送人列表 ,WorkTaskCcVO  */
  workTaskCcList?: API48203Item[];
  /** 任务反馈列表 ,WorkTaskFeedbackVO  */
  feedbackList?: API48203Item[];
  /** 扩展信息 ,WorkTaskExtendVO  */
  extendInfo?: any;
  /** 当前用户是否可评级(0:否,1:是)  */
  canComment?: number;
  /** 子任务数  */
  subTasksNum?: number;
  /** 关联任务数  */
  linkTasksNum?: number;
  /** 被关联任务数  */
  beLinkedTasksNum?: number;
  /** 业务类型,from数据字典  */
  bizType?: string;
  /** 业务数据编号  */
  bizNo?: string;
  /** 当前执行人是否是第一次回复任务,1=是，0=否  */
  firstReply?: number;
  /** 创建子任务的抄送人 ,WorkTaskCcVO  */
  ccIdsForCreatingSubTask?: API48203Item[];
  /** 执行方式：together=共同执行，separate=分别执行  */
  executionType?: string;
  /** 分类编码  */
  categoryCode?: string;
  
};


// 48203 查询任务详情

export interface IUseGetAPI48203Return {
  /** 查询任务详情: 接口请求状态 */
  isAPI48203Loading: boolean;
  /** 查询任务详情: 接口请求返回数据 */
  dataAPI48203: API48203Res;
  /**  查询任务详情: 接口数据请求方法 */
  fetchAPI48203Data:  (inputs: API48203Req, config?: YWRequestConfig) => Promise<API48203Res>;
  /** 查询任务详情: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI48203 = ():IUseGetAPI48203Return => {
  let isMount = true;
  const [isAPI48203Loading, setIsAPI48203Loading] = useState(false);
  const [dataAPI48203, setDataAPI48203] = useState<API48203Res>({} as API48203Res);
  const requestUrl = `${basePath}/team-work/workTask/getWorkTaskDetail`;

  const fetchAPI48203Data = async (inputs: API48203Req, config?: YWRequestConfig): Promise<API48203Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API48203Req>) || {}) as API48203Req;
    
  
    if ( isMount ) {
      setIsAPI48203Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API48203Res>(`${basePath}/team-work/workTask/getWorkTaskDetail?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI48203(res || {} as API48203Res);
        setIsAPI48203Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI48203Loading(false);
      }
      return false as unknown as API48203Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI48203Loading,
    dataAPI48203,
    fetchAPI48203Data,
    requestUrl,
  }
}

